import { NotificationList } from 'components/common/NotificationList'
import { put, takeLatest } from 'redux-saga/effects'
import { makeGetRequest, makePutRequest } from 'utils/api'
import { formatResponse, formatErrorMessage } from 'utils/formatting'

import * as ACT from './actions'
import { PUSH_NOTIFICATION } from 'actions/actionTypes'

function* getNotifications() {
  try {
    const url = '/v1/usernotifications'
    const userNotifications = yield makeGetRequest(url)
    yield put({
      type: ACT.NOTIFICATIONS_FETCH_SUCCESS,
      payload: {
        userNotifications: userNotifications.content
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue fetching the Notifications',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* markRead(action) {
  const { userNotificationId } = action.payload
  try {
    const url = `/v1/usernotifications/${userNotificationId}/markread`
    const userNotifications = yield makePutRequest(url)
    yield put({
      type: ACT.MARKREAD_FETCH_SUCCESS,
      payload: {
        userNotifications
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue to mark the notification as read',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* markUnRead(action) {
  const { userNotificationId } = action.payload
  try {
    const url = `/v1/usernotifications/${userNotificationId}/markunread`
    const userNotifications = yield makePutRequest(url)
    yield put({
      type: ACT.MARKUNREAD_FETCH_SUCCESS,
      payload: {
        userNotifications
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue to mark the notification as unread',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* markAllRead(action) {
  const { userId } = action.payload
  try {
    const url = `/v1/usernotifications/user/${userId}/markallread`
    const userNotifications = yield makePutRequest(url)
    yield put({
      type: ACT.MARKALLREAD_FETCH_SUCCESS,
      payload: {
        userNotifications
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue to mark all notifications as read',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

const notificationsSagas = [
  takeLatest(ACT.NOTIFICATIONS_FETCH_REQUESTED, getNotifications),
  takeLatest(ACT.MARKREAD_FETCH_REQUESTED, markRead),
  takeLatest(ACT.MARKUNREAD_FETCH_REQUESTED, markUnRead),
  takeLatest(ACT.MARKALLREAD_FETCH_REQUESTED, markAllRead)
]

export default notificationsSagas
